module.exports = __webpack_public_path__ + "static/media/SUPERFLO.5e567d54.pdf";